import { ReactComponent as Icon } from "../images/trash.svg";

const TrashIcon = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};
export default TrashIcon;
